import { Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AgencyState } from '../../../redux/models/account/agency.state';
import { getAgencyInfo } from '../../../redux/reducers';
import * as AgencyAction from '../../../redux/actions/account/actions-agency';

@Component({
  standalone: false,
  selector: 'app-agency-page',
  templateUrl: './agency-page.component.html'
})
export class AgencyPageComponent implements OnInit {
  agencyState$: Observable<AgencyState>;

  // localized strings
  readonly linkString = $localize`:@@agency-page.agencyInfoBlockCommercialReprensentative:contacting your Amadeus commercial representative`;
  readonly infoBlockString = $localize`:@@agency-page.agencyInfoBlockYouCanUpdate:You can update your company information by`;
  constructor(private readonly store: Store<AgencyState>) {}

  ngOnInit() {
    this.store.dispatch(new AgencyAction.GetAgency());
    this.agencyState$ = this.store.pipe(select(getAgencyInfo));
  }
}
